import { initiatePassGeneration } from "./registrationHandler";
import { track } from "./analytics.js";

// `marketingConsent` is optional and never validated: the marketing box is a
// free choice and must not stand between the customer and their card.
const submitForm = async (
  businessId,
  email,
  password,
  agreement,
  requiresPassword,
  marketingConsent = false
) => {
  try {
    if (requiresPassword) {
      validateFormEntryWithPassword(email, password, agreement);
    } else {
      validateFormEntryWithoutPassword(email, agreement);
    }
  } catch (validationError) {
    track("enrollment_validation_failed", {
      business_id: businessId,
      error_message: validationError.message,
    });
    throw validationError;
  }
  return await initiatePassGeneration(email.toLowerCase(), businessId, password, {
    marketingConsent: Boolean(marketingConsent),
  });
};

export default submitForm;

const validateFormEntryWithoutPassword = (email, agreement) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email || !emailRegex.test(email)) {
    throw new Error("Please enter a valid email");
  } else if (!agreement) {
    throw new Error(
      "Please make sure you have read and are happy with the terms of service"
    );
  }
};

const validateFormEntryWithPassword = (email, password, agreement) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email || !emailRegex.test(email)) {
    throw new Error("Please enter a valid email");
  } else if (!password || password.length < 5) {
    throw new Error("Please enter a valid password");
  } else if (!agreement) {
    throw new Error(
      "Please make sure you have read and are happy with the terms of service"
    );
  }
};
